import { Component, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

import { PrismDialogService } from '@shure/prism-angular-components';

import { AboutDialogComponent, DialogData } from '../dialogs';
@Component({
	selector: 'sh-top-ribbon',
	templateUrl: './top-ribbon.component.html',
	styleUrls: ['./top-ribbon.component.scss']
})
export class TopRibbonComponent {
	@Input() public title!: string;
	@Input() public appVersion!: string;
	@Input() public showAccount = true;
	@Input() public showAbout = false;
	@Input() public showShureLogoWhenSignedIn = true;
	@Input() public isUserAuthenticated: boolean | null = false;
	@Output() public logoutClicked: EventEmitter<void> = new EventEmitter();

	constructor(
		private router: Router,
		private readonly dialogService: PrismDialogService,
		private readonly viewContainer: ViewContainerRef
	) {}

	public goToAccount(): void {
		this.router.navigateByUrl('/account');
	}
	public openAboutDialog(): void {
		this.dialogService.openDialog<AboutDialogComponent, DialogData, unknown>(
			AboutDialogComponent,
			this.viewContainer,
			{
				data: { title: this.title, appVersion: this.appVersion }
			}
		);
	}

	public logout(): void {
		this.logoutClicked.next();
	}

	public onLogoClick(): void {
		this.router.navigateByUrl('/');
	}
}
